import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import SmoothScroll from "@/components/SmoothScroll";
import AutoEnquiryPopup from "@/components/AutoEnquiryPopup";

export default function Layout() {
  return (
    <SmoothScroll>
      <div className="grain relative min-h-screen bg-[var(--tx-bg)]">
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
        <FloatingActions />
        <AutoEnquiryPopup />
      </div>
    </SmoothScroll>
  );
}
